<script setup>
// Recursively renders a JSON value as key/value rows.
// Objects use their keys; arrays use their index. Nested objects/arrays are
// rendered with a left offset so the hierarchy stays readable. Values are shown
// exactly as received – they are not converted.
defineProps({
  data: {
    type: [Object, Array],
    required: true,
  },
});

const isComplex = value => value !== null && typeof value === 'object';

const formatValue = value => String(value);

const entriesOf = data =>
  Array.isArray(data)
    ? data.map((value, index) => [String(index), value])
    : Object.entries(data);
</script>

<template>
  <div>
    <div v-for="[key, value] in entriesOf(data)" :key="key" class="py-1.5">
      <div class="items-center flex justify-between mb-1.5">
        <span class="text-sm font-medium text-slate-800 dark:text-slate-100">
          {{ key }}
        </span>
      </div>
      <CustomDataProviderValue
        v-if="isComplex(value)"
        :data="value"
        class="pl-3"
      />
      <div v-else class="break-words">{{ formatValue(value) }}</div>
    </div>
  </div>
</template>
